module.exports = __webpack_public_path__ + "img/laurent.244037bc.jpg";